/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { accountMemberUpdateSchema } from "../accountMemberUpdateSchema.ts";
import { errorResponseSchema } from "../errorResponseSchema.ts";
import { z } from "zod";

export const updateMemberByIdPathParamsSchema = z.object({
      "id": z.string().describe("ID unique du membre à mettre à jour.")
      })

export const updateMemberByIdHeaderParamsSchema = z.object({
      "X-Client-Id": z.string().describe("ID du client/application pour lequel récupérer les informations utilisateur.")
      })

/**
 * @description Membre mis à jour avec succès.
 */
export const updateMemberById200Schema = z.any()

/**
 * @description Réponse d\'erreur standard
 */
export const updateMemberById500Schema = z.lazy(() => errorResponseSchema).describe("Réponse d'erreur avec message et code de statut")

export const updateMemberByIdMutationRequestSchema = z.lazy(() => accountMemberUpdateSchema)

export const updateMemberByIdMutationResponseSchema = z.lazy(() => updateMemberById200Schema)